module.exports = __webpack_public_path__ + "2fcf00014353c661371015e2886cdbc3.MP3";